export default {
  row1 : [
  {
    column: "column1",
    rows: {
      row1: [
        {
          name: "importBondCertName",
          label: "Bond/Cert",
          component: "dropdown",
          width: "100%",
          options: [
            { label: "Bond", value: "Bond" },
            { label: "Certificate", value: "Certificate" }
          ]

        },
        {
          name: "importBondCertType",
          label: "Type",
          component: "dropdown",
          endIconName: "LuSearch",
          width: "100%",
          options: [
            { label: "Cash Deposit", value: "Cash Deposit" },
            { label: "Central Excise Certificate", value: "Central Excise Certificate" },
            { label: "Import under Sec. 143", value: "Import under Sec. 143" },
            { label: "DEEC Bond", value: "DEEC Bond" },
            { label: "Import under Sec. 143 - Officer Determined", value: "Import under Sec. 143 - Officer Determined" },
            { label: "EPCG/AA/DFIA (large/established exporters, PSU, Star Export House, etc.)", value: "EPCG/AA/DFIA (large/established exporters, PSU, Star Export House, etc.)" },
            { label: "EPCG/AA/DFIA (others not covered under E1)", value: "EPCG/AA/DFIA (others not covered under E1)" },
            { label: "EPCG/AA/DFIA (custodians, service providers in specific sectors)", value: "EPCG/AA/DFIA (custodians, service providers in specific sectors)" },
            { label: "EPCG/AA/DFIA - Others", value: "EPCG/AA/DFIA - Others" },
            { label: "EPCG Bond", value: "EPCG Bond" },
            { label: "IGCR Benefits", value: "IGCR Benefits" },
            { label: "EOU Bond", value: "EOU Bond" },
            { label: "End use Bond", value: "End use Bond" },
            { label: "EPCG/AA/DFIA - Officer Determined", value: "EPCG/AA/DFIA - Officer Determined" },
            { label: "ITC Bond", value: "ITC Bond" },
            { label: "Jobbing", value: "Jobbing" },
            { label: "Letter of Guarantee", value: "Letter of Guarantee" },
            { label: "MOOWR - Private Warehouse", value: "MOOWR - Private Warehouse" },
            { label: "Miscellaneous", value: "Miscellaneous" },
            { label: "MOOWR - Private Warehouse - Officer Determined", value: "MOOWR - Private Warehouse - Officer Determined" },
            { label: "National Bond", value: "National Bond" },
            { label: "Provisional Assessment - Carotar (PSU/Govt)", value: "Provisional Assessment - Carotar (PSU/Govt)" },
            { label: "Provisional Assessment - Carotar (Others incl. AEO)", value: "Provisional Assessment - Carotar (Others incl. AEO)" },
            { label: "Provisional Assessment - SVB (initial non-compliance, others)", value: "Provisional Assessment - SVB (initial non-compliance, others)" },
            { label: "Provisional Assessment - SVB (AEO T1, initial non-compliance)", value: "Provisional Assessment - SVB (AEO T1, initial non-compliance)" },
          ],          
        },
      ],
      row2: [
        {
          name: "importBondCertNumber",
          label: "Number",
          component: "text-field",
          width: "100%",
        },
        {
          name: "importBondCertDateTime",
          label: "Date",
          component: "dateselector",
          width: "100%",
        },
      ],
      row3: [
        {
          name: "importBondCertCommissionerate",
          label: "Rate",
          component: "text-field",
          width: "100%",
        },
        {
          name: "importBondCertDivision",
          label: "Division",
          component: "text-field",
          width: "100%",
        },
      ],
      row4: [
        {
          name: "importBondCertRange",
          label: "Range",
          component: "text-field",
          width: "100%",
        },
        {
          name: "importBondCertRegisteredPort",
          label: "Registered Port",
          component: "text-field",
          endIconName: "Search",
          width: "100%",
          type:"autocomplete",
          endpoint:"getPorts",
          useParams : "general.exportTransportMode",
          endpointWithParams : "portType",
        },
      ],
    },
  },
]
}
